import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/context/AuthContext";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent! We'll reply shortly.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid lg:grid-cols-2 gap-16">
      <div>
        <span className="label text-cinnabar">Get in touch</span>
        <h1 className="font-serif font-light text-5xl sm:text-6xl tracking-tighter mt-4">Contact us</h1>
        <p className="text-clay mt-6 text-lg max-w-md">Questions about courses, teacher training or studying in China? We're here to help.</p>
        <div className="mt-12 space-y-6">
          {[[Mail, "info@cclpt.com"], [Phone, "+91 98765 43210"], [MapPin, "New Delhi, India"]].map(([Icon, v], i) => (
            <div key={i} className="flex items-center gap-4">
              <span className="w-11 h-11 border border-black/10 bg-white flex items-center justify-center text-cinnabar"><Icon size={18} /></span>
              <span className="text-ink">{v}</span>
            </div>
          ))}
        </div>
      </div>
      <form onSubmit={submit} className="border border-black/10 bg-white p-8 space-y-5" data-testid="contact-form">
        {["name", "email", "subject"].map((f) => (
          <div key={f}>
            <label className="label text-clay">{f}</label>
            <input required type={f === "email" ? "email" : "text"} value={form[f]}
              onChange={(e) => setForm({ ...form, [f]: e.target.value })} data-testid={`contact-${f}`}
              className="w-full mt-1.5 px-4 py-3 border border-black/10 focus:outline-none focus:ring-1 focus:ring-cinnabar" />
          </div>
        ))}
        <div>
          <label className="label text-clay">Message</label>
          <textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
            data-testid="contact-message"
            className="w-full mt-1.5 px-4 py-3 border border-black/10 focus:outline-none focus:ring-1 focus:ring-cinnabar" />
        </div>
        <button disabled={busy} data-testid="contact-submit"
          className="w-full py-4 bg-ink text-rice font-medium hover:bg-cinnabar transition-colors duration-300 disabled:opacity-60">
          {busy ? "Sending…" : "Send Message"}
        </button>
      </form>
    </div>
  );
}
